module.exports = __webpack_public_path__ + "img/28_22.7e3e6796.png";